export enum type  {
    OBJECT = 1,    
    BOOLEAN = 2,    
    NUMBER = 3, 
    STRING = 4,
}